import React, { useState } from "react";
import MDBox from "components/MDBox";
import MergerCards from "./components/MergeCards";

const Merger: React.FC = () => {
  const [selectedDatasetId, setSelectedDatasetId] = useState<string | null>(null);

  const [outputTableName, setOutputTableName] = useState<string>("");

  return (
    <MDBox sx={{ marginTop: "5px" }}>
      <MergerCards
        setDatasetId={setSelectedDatasetId}
        selectedDatasetId={selectedDatasetId}
        outputTableName={outputTableName}
        setOutputTableName={setOutputTableName}
      />
    </MDBox>
  );
};

export default Merger;
